import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route, } from "react-router-dom";

import Layout from "./WorkFinitySRC/Module Parent Route/HomeRoute/Features/Layout";
import RequireAuth from "./WorkFinitySRC/Components/RequireAuth/RequireAuth.jsx";
import "./App.css";
//import Home from "./WorkFinitySRC/Module Parent Route/HomeRoute/Final Screen View Components/HomeRoute";
//import SignIn from "./WorkFinitySRC/Non-Nested Components/Sign-in/Final Screen View Components/SignIn";
//import UsersManagementModule from "./WorkFinitySRC/Module Parent Route/UsersManagement/usersManagement";
//import APIsManagementModule from "./WorkFinitySRC/Module Parent Route/APIsManagement/apisManagement";
//import RolesManagementModule from "./WorkFinitySRC/Module Parent Route/RolesManagement/rolesManagement";
//import TemplateManagementModule from "./WorkFinitySRC/Module Parent Route/TemplatesManagement/templateManagement";
//import DocumentsManagementModule from "./WorkFinitySRC/Module Parent Route/DocumentsManagement/documentsManagement";
//import ProfileManagementModule from "./WorkFinitySRC/Module Parent Route/ProfileMangement/profileManagement";

import { SnackbarProvider, useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { notificationDetailsSelector } from "./WorkFinitySRC/Store/NotificationStore/notification.slice.selector";
import BackdropComp from "./WorkFinitySRC/Components/common/backdrop/backdrop";
import LoginLayout from "./WorkFinitySRC/Module Parent Route/HomeRoute/Features/LoginLayout.jsx";
import ForgotPassword from "./WorkFinitySRC/Non-Nested Components/Sign-in/Final Screen View Components/ForgotPass/ForgotPassword.jsx";
import ResetPassword from "./WorkFinitySRC/Nested Module Components/ProfileManagement/Final Screen View Components/resetPassword.jsx";



const HomeLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/HomeRoute/Final Screen View Components/HomeRoute"));
const SignInLazy = lazy(() => import("./WorkFinitySRC/Non-Nested Components/Sign-in/Final Screen View Components/SignIn"));
const UsersManagementModuleLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/UsersManagement/usersManagement"));
const APIsManagementModuleLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/APIsManagement/apisManagement"));
const RolesManagementModuleLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/RolesManagement/rolesManagement"));
const TemplateManagementModuleLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/TemplatesManagement/templateManagement"));
const DocumentsManagementModuleLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/DocumentsManagement/documentsManagement"));
const ProfileManagementModuleLazy = lazy(() => import("./WorkFinitySRC/Module Parent Route/ProfileMangement/profileManagement"))

const MainContent = () => {
  //const location = useLocation();
  //console.log(location.state?.from?.pathname);
  const { enqueueSnackbar } = useSnackbar();
  const notificationDetails = useSelector(notificationDetailsSelector);
  const notificationHandlerVariant = (
    textMessage = "This is Temprory Message",
    variant = "info"
  ) => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(textMessage, { variant });
  };

  useEffect(() => {
    if (notificationDetails.message.length > 5) {
      const { message, variant } = notificationDetails;

      notificationHandlerVariant(message, variant);
    }
  }, [notificationDetails]);
  return (
    <>
      <Suspense fallback={<BackdropComp isLoading={true} />}>
        <Routes>
          <Route element={<LoginLayout />}>
            <Route path="login" element={<SignInLazy />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password" element={<ResetPassword />} />
          </Route>
          <Route path="/" element={<Layout />}>
            <Route element={<RequireAuth />}>
              <Route index element={<HomeLazy />} />
              <Route path="list-users/*" element={<UsersManagementModuleLazy />} />
              <Route path="manage-Apis/*" element={<APIsManagementModuleLazy />} />
              <Route path="manage-Roles/*" element={<RolesManagementModuleLazy />} />
              <Route
                path="manage-Templates/*"
                element={<TemplateManagementModuleLazy />}
              />
              <Route
                path="manage-Documents/*"
                element={<DocumentsManagementModuleLazy />}
              />
              <Route
                path="manage-Profile/*"
                element={<ProfileManagementModuleLazy />}
              />
            </Route>

            {/* </Route> */}
          </Route>
        </Routes>
      </Suspense>

    </>
  );
};

function App() {
  return (
    <SnackbarProvider maxSnack={1}>
      <MainContent />
    </SnackbarProvider>
  );
}

export default App;
